import * as React from 'react';

var Simple = function Simple() {
  //   const { getPrefixCls } = React.useContext(ConfigContext);
  //   const prefixCls = getPrefixCls('empty-img-simple');
  return /*#__PURE__*/React.createElement("div", null, "\u666E\u901A\u56FE\u7247");
};

export default Simple;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-empty/src/simpleEmpty.js